<template>
  <div class="search">
    <div class="search-inner">
      <div class="firstChild">Search</div>
      <div class="keyword">
        <p class="keyword_p1">By identifier or keyword</p>

        <el-form ref="formFirst" style="display:flex;" :inline="true" :rules="rules" :model="first_form">
          <el-form-item class="downloadItem1" label="Species" prop="specie">
            <el-select clearable size="large" v-model="first_form.specie" placeholder="Choose">
              <el-option v-for="(item, index) in firstSpeciesOptions" :key="index" :label="item.label" :value="item.label == 'All species' ? '' : item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="firstItem">
            <el-input size="large" style="width:100%;" class="keyword_input" v-model="keyword_input" placeholder="lncRNA locus ID,lncRNA locus accession or keyword"></el-input>
          </el-form-item>
        </el-form>
        <el-checkbox-group v-model="checkList">
          <el-checkbox label="Validated LncRNA"></el-checkbox>
          <el-checkbox label="Predicted LncRNA"></el-checkbox>
          <el-checkbox label="Genes"></el-checkbox>
        </el-checkbox-group>

        <el-row style="margin: 20px 0px 40px 0;">
          <el-button class="btnSearch" @click="Example('keyword')">Example</el-button>
          <el-button class="btnSearch" @click="Search('keyword')">Search</el-button>
          <el-button class="btnReset" @click="Reset('keyword')">Reset</el-button>
        </el-row>
      </div>
      <div class="sequence">
        <p class="keyword_p1">By Sequence</p>
        <el-form ref="form1" :inline="true" :model="sequence_form">
          <el-form-item style="width:100%;" class="firstItem">
            <el-input type="textarea" :autosize="{ minRows: 4, maxRows: 6}" placeholder="Input a FASTA sequence here" v-model="sequence_form.query_sequence"
              style="width:100%;">
            </el-input>
          </el-form-item>
          <el-form-item label="Search method" prop="search_method">
            <el-select clearable style="width:200px;" size="large" v-model="sequence_form.search_method" placeholder="Choose">
              <el-option v-for="(item, index) in methodOptions" :key="index" :label="item" :value="item">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Species" prop="species">
            <el-select clearable style="width:200px;" size="large" v-model="sequence_form.species" placeholder="Choose">
              <el-option v-for="(item, index) in SpeciesOptions" :key="index" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Database" prop="database">
            <el-select clearable style="width:200px;" size="large" v-model="sequence_form.database" placeholder="Choose">
              <el-option v-for="item in DatabaseOptions" :key="item.label" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="E-value">
            <el-select clearable style="width:200px;" size="large" v-model="sequence_form.evalue" placeholder="Choose">
              <el-option v-for="(item, index) in valueOptions" :key="index" :label="item" :value="item">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <p class="file_p">
          or upload sequence FASTA file
          <a href="javascript:;" class="file">Browse
            <input type="file" name="file" ref="file" @change="handleUpdate($event)" />
          </a>
          <span>{{fileName}}</span>
        </p>
        <el-row style="margin: 20px 0px 40px 0;">
          <el-button class="btnSearch" @click="Example('sequence_form')">Example</el-button>
          <el-button class="btnSearch" @click="Search('sequence_form')">Search</el-button>
          <el-button class="btnReset" @click="Reset('sequence_form')">Reset</el-button>
        </el-row>
      </div>
      <div class="genomicLocation">
        <p class="keyword_p1">By genomic location</p>
        <el-form ref="form2" :inline="true" :model="genomic_form">
          <el-form-item label="Species">
            <el-select clearable size="large" v-model="genomic_form.specie" @change="locationChange" placeholder="Choose">
              <el-option v-for="(item, index) in genSpeciesOptions" :key="index" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Chr">
            <el-select clearable size="large" v-model="genomic_form.chromesome_scaffold" placeholder="Choose">
              <el-option v-for="(item, index) in genScaffoldOptions" :key="index" :label="item.chr" :value="item.chr">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Start">
            <el-input size="large" v-model="genomic_form.start"></el-input>
          </el-form-item>
          <el-form-item label="End">
            <el-input size="large" v-model="genomic_form.end"></el-input>
          </el-form-item>
        </el-form>
        <el-row style="margin: 20px 0px 40px 0;">
          <el-button class="btnSearch" @click="Example('genomic_form')">Example</el-button>
          <el-button class="btnSearch" @click="Search('genomic_form')">Search</el-button>
          <el-button class="btnReset" @click="Reset('genomic_form')">Reset</el-button>
        </el-row>
      </div>
      <div class="expression">
        <p class="keyword_p1">By expression</p>
        <el-form ref="form4" :inline="true" :model="expression_form">
          <el-form-item label="Species">
            <el-select clearable size="large" v-model="expression_form.species" @change="expressionChange" placeholder="Choose">
              <el-option v-for="(item, index) in expSpeciesOptions" :key="index" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Tissue">
            <el-select size="large" v-model="expression_form.tissue" placeholder="Choose">
              <el-option v-for="(item, index) in exptissueOptions" :key="index" :label="item.tissue" :value="item.tissue">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Value">
            <el-input style="width:200px;" size="large" v-model="expression_form.start_value"></el-input>&nbsp;&nbsp;-&nbsp;&nbsp;
            <el-input style="width:200px;" size="large" v-model="expression_form.end_value"></el-input>
          </el-form-item>
        </el-form>
        <el-row style="margin: 20px 0px 40px 0;">
          <el-button class="btnSearch" @click="Example('expression_form')">Example</el-button>
          <el-button class="btnSearch" @click="Search('expression_form')">Search</el-button>
          <el-button class="btnReset" @click="Reset('expression_form')">Reset</el-button>
        </el-row>
      </div>
      <!-- <div class="targetGenes">
        <p class="keyword_p1">By target genes</p>
        <el-form ref="form5" :inline="true" :model="targetGenes_form" label-position='left'>
          <el-form-item label="Target method">
            <el-select clearable size="large" v-model="targetGenes_form.target_method" placeholder="Choose">
              <el-option v-for="(item, index) in genesSpeciesOptions" :key="index" :label="item.methods" :value="item.methods">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Level of interaction">
            <el-select clearable size="large" v-model="targetGenes_form.Level_of_interaction" placeholder="Choose">
              <el-option v-for="(item, index) in geneslevelOptions" :key="index" :label="item.level_of_interaction" :value="item.level_of_interaction">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Pmid">
            <el-input size="large" v-model="targetGenes_form.pmid"></el-input>
          </el-form-item>
        </el-form>
        <el-row style="margin: 20px 0px 40px 0;">
          <el-button class="btnSearch" @click="Example('targetGenes_form')">Example</el-button>
          <el-button class="btnSearch" @click="Search('targetGenes_form')">Search</el-button>
          <el-button class="btnReset" @click="Reset('targetGenes_form')">Reset</el-button>
        </el-row>
      </div> -->
      <div class="heatmap">
        <p class="keyword_p1">By tissue specific expression</p>
        <el-form ref="form5" :inline="true" :model="heatmap_form" label-position='left'>
          <el-form-item label="Species">
            <el-select size="large" v-model="heatmap_form.specie" @change="heatmapChange" placeholder="Choose">
              <el-option v-for="(item, index) in heatSpacieOptions" :key="index" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Tissue">
            <el-select size="large" v-model="heatmap_form.tissue" placeholder="Choose">
              <el-option v-for="(item, index) in TissueOptions" :key="index" :label="item" :value="item">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <el-row style="margin: 20px 0px 40px 0;">
          <el-button class="btnSearch" @click="Example('heatmap_form')">Example</el-button>
          <el-button class="btnSearch" @click="Search('heatmap_form')">Search</el-button>
          <el-button class="btnReset" @click="Reset('heatmap_form')">Reset</el-button>
        </el-row>
      </div>
    </div>
  </div>
</template>
<script>
let url = {
  species: "species/search_key_word",
  species_gene: "species/search_gene_key_word",
  blast_data: "blast/blast_data",
  blast_species_data: "blast/blast_species_data",
  blast_database_data: "blast/blast_database_data",
  blast_evalue: "blast/blast_evalue", // blast value下拉框接口
  location: "species/search_genomic_location",
  location_gene: "species/search_gene_genomic_location",
  expression: "species/search_expression",
  expression_gene: "species/search_gene_expression",
  genes: "species/search_target_genes",
  genes_gene: "species/search_gene_target",
  specie_all: "species/specie_all",
  search_chr: "species/search_chr",
  specie_tissue: "species/specie_tissue",
  specie_target_method: "species/specie_target_method", // target_method下拉框
  specie_level_interaction: "species/specie_level_interaction", // level_interaction下拉框
  heatmap_tissue: "species/heatmap_tissue",
  specie_name_heatmap: "species/specie_name_heatmap",
};
import bus from "../common/bus";
export default {
  data() {
    return {
      first_form: {
        specie: 'Arabidopsis_thaliana'
      },
      keyword_input: "",
      checkList: [],
      sequence_form: {
        search_method: "",
        query_sequence: "",
        database: "",
        species: "",
        evalue: "",
      },
      rules: {
        search_method: [
          { required: true, message: '', trigger: 'change' }
        ],
        query_sequence: [
          { required: true, message: '', trigger: 'blur' }
        ],
        database: [
          { required: true, message: '', trigger: 'change' }
        ],
        species: [
          { required: true, message: '', trigger: 'change' }
        ]
      },
      methodOptions: ['blastp', 'blastx', 'blastn', 'tblastn', 'tblastx'],
      DatabaseOptions: [
        {
          label: 'lncRNA Sequences',
          value: 'lncRNA'
        },
        {
          label: 'CDS Sequences',
          value: 'cds'
        },
        {
          label: 'Genome Sequences',
          value: 'chromosome'
        },
        {
          label: 'Peptide Sequences',
          value: 'pep'
        },
        {
          label: 'Gene Sequences',
          value: 'gene'
        }
      ],
      SpeciesOptions: [],
      valueOptions: ['1e-20', '1e-10', '1e-5', '0.01', '0.1', '1', '10', '100'],
      genomic_form: {
        specie: "",
        chromesome_scaffold: "",
        start: "",
        end: "",
      },
      genSpeciesOptions: [],
      firstSpeciesOptions: [],
      genScaffoldOptions: [],
      expression_form: {
        species: "",
        tissue: "",
        start_value: "",
        end_value: ""
      },
      expSpeciesOptions: [],
      heatSpacieOptions: [],
      exptissueOptions: [],
      targetGenes_form: {
        target_method: "",
        Level_of_interaction: "",
        pmid: "",
      },
      genesSpeciesOptions: [],
      geneslevelOptions: [],
      heatmap_form: {
        specie: "",
        tissue: ''
      },
      TissueOptions: [],
      file: "",
      fileName: ''
    };
  },
  mounted() {
    this.specie_all();
    this.heatSpecie_all();
    this.specie_target_method();
    this.specie_level_interaction();
    // this.blast_species_data();
  },
  methods: {
    Example(param) {
      let params = "";
      if (param == "keyword") {
        this.first_form.specie = 'Arabidopsis_thaliana'
        this.keyword_input = "COLDAIR";
      } else if (param == "genomic_form") {
        this.genomic_form = {
          specie: "Arabidopsis_thaliana",
          chromesome_scaffold: "chr1",
          start: "100000",
          end: "1000000",
        };
      } else if (param == "expression_form") {
        this.expression_form = {
          species: "Arabidopsis_thaliana",
          tissue: "root",
          start_value: "0.6",
          end_value: "0.8"
        };
      } else if (param == "targetGenes_form") {
        this.targetGenes_form = {
          target_method: "RT-PCR",
          Level_of_interaction: "RNA-DNA",
          pmid: "25018019.0",
        };
      } else if (param == "heatmap_form") {
        this.heatmap_form = {
          specie: "Amborella_trichopoda",
          tissue: 'bud'
        };
      } else if (param == "sequence_form") {
        this.sequence_form = {
          search_method: "blastn",
          query_sequence:
            ">AT1G51370.2\nATGGTGGGTGGCAAGAAGAAAACCAAGATATGTGACAAAGTGTCACATGAGGAAGATAGGATAAGCCAGTTACCGGAACC\nTTTGATATCTGAAATACTTTTTCATCTTTCTACCAAGGACTCTGTCAGAACAAGCGCTTTGTCTACCAAATGGAGATATC",
          database: "cds",
          species: "Arabidopsis_thaliana",
          evalue: "1e-5",
        };
      }
    },
    Search(param) {
      sessionStorage.removeItem("tableParams");
      let params = "";
      let urls = "";
      let urls2 = "";
      let types = 1; // 1,2,3 三种不用的详情表格
      if (param == "keyword") {
        params = {
          specie_name: this.first_form.specie,
          search: this.keyword_input,
          tag: this.checkList.toString()
        };
        urls = url.species;
        urls2 = url.species_gene;
        types = 1;
      } else if (param == "genomic_form") {
        params = this.genomic_form;
        urls = url.location;
        urls2 = url.location_gene;
        types = 1;
      } else if (param == "expression_form") {
        params = this.expression_form;
        urls = url.expression;
        urls2 = url.expression_gene;
        types = 1;
      } else if (param == "targetGenes_form") {
        params = this.targetGenes_form;
        urls = url.genes;
        urls2 = url.genes_gene;
        types = 1;
      } else if (param == "heatmap_form") {
        params = this.heatmap_form;
        urls = url.genes;
        urls2 = url.genes_gene;
        types = 4;
      } else if (param == "sequence_form") {
        params = this.sequence_form;
        urls = url.blast_data;
        types = 3;
      }
      let tableParams = {
        urls: urls,
        urls2: urls2,
        params: params,
        types: types,
      };
      sessionStorage.setItem("tableParams", JSON.stringify(tableParams));
      if (types == 3) {
        this.$refs['form1'].validate((valid) => {
          if (valid) {
            this.getData()
          } else {
            return false;
          }
        });
      } else if (types == 4) {
        this.$router.push("/Heatmap");
      } else {
        if (param == "keyword" && this.keyword_input === "") {
          this.$confirm('No keywords were detected. Click ‘GoOn’ button to show all records, or click ‘Back’ to retype your keywords.', 'Tips', {
            confirmButtonText: 'GoOn',
            cancelButtonText: 'Back',
            type: 'warning'
          }).then(() => {
            this.$router.push("/searchList");
          })
        } else {
          this.$router.push("/searchList");
        }
      }
    },
    getData() {
      let formData = new FormData()
      formData.append('species', this.sequence_form.species)
      formData.append('database', this.sequence_form.database)
      formData.append('file', this.file)
      formData.append('query_sequence', this.sequence_form.query_sequence)
      formData.append('search_method', this.sequence_form.search_method)
      formData.append('evalue', this.sequence_form.evalue)
      let config = {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
      sessionStorage.removeItem("tableParams3");
      this.$axios.post(url.blast_data, formData, config).then(res => {
        if (res.data.code == 200) {
          sessionStorage.setItem("tableParams3", JSON.stringify(res.data.data));
          this.$router.push("/searchList");
        } else {
          this.$message.warning(res.data.msg);
        }
      }).catch(err => {
        this.$message.warning(err.data.msg);
      });
    },
    Reset(param) {
      if (param == "keyword") {
        this.keyword_input = "";
      } else if (param == "genomic_form") {
        this.genomic_form = {
          specie: "",
          chromesome_scaffold: "",
          start: "",
          end: "",
        };
      } else if (param == "expression_form") {
        this.expression_form = {
          specie: "",
          tissue: "",
          start_value: "",
          end_value: ""
        };
      } else if (param == "targetGenes_form") {
        this.targetGenes_form = {
          target_method: "",
          Level_of_interaction: "",
          pmid: "",
        };
      } else if (param == "heatmap_form") {
        this.heatmap_form = {
          specie: "",
          tissue: ''
        };
      } else if (param == "sequence_form") {
        this.fileName = ''
        this.file = ''
        // this.methodOptions = [];
        // this.DatabaseOptions = [];
        // this.SpeciesOptions = [];
        // this.valueOptions = [];
        this.sequence_form = {
          search_method: "",
          query_sequence: "",
          database: "",
          species: "",
          evalue: "",
        }
        this.$refs['form1'].resetFields()
      }
    },
    locationChange(val) {
      this.search_chr(val);
    },
    specie_all() {
      this.http.get(url.specie_all, {}).then((res) => {
        if (res.data.code == 200) {
          this.SpeciesOptions = JSON.parse(JSON.stringify(res.data.data))
          this.genSpeciesOptions = res.data.data;
          this.firstSpeciesOptions = res.data.data;
          this.firstSpeciesOptions.unshift({
            label: 'All species'
          })
          this.expSpeciesOptions = res.data.data;
        }
      }).catch((err) => {
        this.$message.warning(err.response.data.error.message);
      });
    },
    search_chr(val) {
      this.genScaffoldOptions = [];
      this.genomic_form.chromesome_scaffold = "";
      this.http
        .get(url.search_chr, { specie: val })
        .then((res) => {
          if (res.data.code == 200) {
            this.genScaffoldOptions = res.data.data;
          }
        })
        .catch((err) => {
          this.$message.warning(err.response.data.error.message);
        });
    },
    // blast_species_data(val) {
    //   this.DatabaseOptions = [];
    //   // this.genomic_form.chromesome_scaffold = "";
    //   this.http.get(url.blast_species_data, {}).then(res => {
    //     if (res.data.code == 200) {
    //       console.log(res.data.data)
    //       this.SpeciesOptions = res.data.data;
    //     }
    //   }).catch(err => {
    //     this.$message.warning(err.response.data.error.message);
    //   });
    // },
    speciesChange(val) {
      this.DatabaseOptions = [];
      this.sequence_form.database = "";
      this.http
        .get(url.blast_database_data, { species: val })
        .then((res) => {
          if (res.data.code == 200) {
            this.DatabaseOptions = res.data.data;
          }
        })
        .catch((err) => {
          this.$message.warning(err.response.data.error.message);
        });
      this.valueOptions = [];
      this.sequence_form.evalue = "";
      this.http
        .get(url.blast_evalue, { species: val })
        .then((res) => {
          if (res.data.code == 200) {
            this.valueOptions = res.data.data;
          }
        })
        .catch((err) => {
          this.$message.warning(err.response.data.error.message);
        });
    },
    expressionChange(val) {
      this.exptissueOptions = [];
      this.expression_form.tissue = "";
      this.http
        .get(url.specie_tissue, { specie: val })
        .then((res) => {
          if (res.data.code == 200) {
            this.exptissueOptions = res.data.data;
            this.expression_form.tissue = this.exptissueOptions[0].tissue
          }
        })
        .catch((err) => {
          this.$message.warning(err.response.data.error.message);
        });
    },
    specie_target_method() {
      this.http
        .get(url.specie_target_method, {})
        .then((res) => {
          if (res.data.code == 200) {
            this.genesSpeciesOptions = res.data.data;
          }
        })
        .catch((err) => {
          this.$message.warning(err.response.data.error.message);
        });
    },
    specie_level_interaction() {
      this.http
        .get(url.specie_level_interaction, {})
        .then((res) => {
          if (res.data.code == 200) {
            this.geneslevelOptions = res.data.data;
          }
        })
        .catch((err) => {
          this.$message.warning(err.response.data.error.message);
        });
    },
    handleUpdate(event) {
      this.fileName = event.target.files[0].name
      this.file = event.target.files[0]
      sessionStorage.setItem("files", JSON.stringify(event.target.files[0]));
    },
    // heatmap
    heatSpecie_all() {
      this.http.get(url.specie_name_heatmap, {}).then((res) => {
        if (res.data.code == 200) {
          this.heatSpacieOptions = res.data.data;
          this.heatmap_form.specie = res.data.data[0].value
          this.getTissueOptions()
        }
      }).catch((err) => {
        this.$message.warning(err.response.data.error.message);
      });
    },
    heatmapChange() {
      this.getTissueOptions()
    },
    getTissueOptions() {
      this.heatmap_form.tissue = ''
      this.TissueOptions = []
      let params = {
        specie: this.heatmap_form.specie
      }
      this.http.get(url.heatmap_tissue, params).then((res) => {
        if (res.data.code == 200) {
          this.TissueOptions = res.data.data;
          this.heatmap_form.tissue = res.data.data[0]
        }
      }).catch((err) => {
        this.$message.warning(err.data.msg);
      });
    },
  },
  filters: {
    replaceSequences: function (input) {
      return input.replace(/Seq/g, 'Sequences')
    }
  }
};
</script>

<style scoped>
a {
  text-decoration: none;
  color: #000;
}
ul,
li {
  list-style: none;
}
.search {
  width: 100%;
  padding: 30px 0px;
  background: #f5f9fc;
}
.el-form-item--mini.el-form-item,
.el-form-item--small.el-form-item {
  margin-right: 20px;
}
.search .search-inner {
  width: 1200px;
  padding: 0px 20px;
  margin: 0 auto;
  overflow: hidden;
  background: rgba(255, 255, 255, 1);
}
.search .search-inner .firstChild {
  height: 50px;
  line-height: 50px;
  font-size: 30px;
  font-family: PingFang SC;
  font-weight: bold;
  color: rgba(51, 51, 51, 1);
  /* line-height: 28px;
  padding-top: 30px; */
  border-bottom: 1px solid rgba(215, 217, 219, 1);
}
.search .search-inner .keyword {
  height: auto;
}
.keyword_p1 {
  margin-top: 30px;
  margin-bottom: 0;
  height: 47px;
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: bold;
  color: rgba(51, 51, 51, 1);
}
/* .search .search-inner .keyword .keyword_input /deep/ .el-input__inner {
  height: 50px;
  line-height: 50px;
} */
.btnSearch {
  width: 126px;
  height: 40px;
  background: rgba(139, 182, 68, 1);
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #fff;
  outline: none;
  border: none;
}
.btnReset {
  width: 126px;
  height: 40px;
  background: #f1f1f1;
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #333;
  outline: none;
  border: none;
}
.search .search-inner .sequence {
  height: auto;
  border-top: 1px solid #8bb644;
}
.search .search-inner .genomicLocation {
  height: auto;
  border-top: 1px solid #8bb644;
}
.search .search-inner .expression {
  height: auto;
  border-top: 1px solid #8bb644;
}
.search .search-inner .targetGenes {
  height: auto;
  border-top: 1px solid #8bb644;
}
.search .search-inner .heatmap {
  height: auto;
  border-top: 1px solid #8bb644;
}
.firstItem /deep/ .el-form-item__content {
  width: 100%;
}
.file_p {
  margin-top: 0;
  margin-bottom: 30px;
}
.file_p span {
  display: inline-block;
  padding-left: 30px;
}
.file {
  position: relative;
  display: inline-block;
  background: rgba(139, 182, 68, 1);
  border-radius: 4px;
  overflow: hidden;
  color: #fff;
  text-decoration: none;
  text-indent: 0;
  line-height: 30px;
  cursor: pointer;
  width: 100px;
  height: 30px;
  text-align: center;
  top: 8px;
  left: 15px;
}

.file input {
  position: absolute;
  font-size: 100px;
  right: 0;
  top: 0;
  opacity: 0;
  cursor: pointer;
}

.file:hover {
  color: #fff;
  text-decoration: none;
}
.firstItem {
  flex: 1;
}
.firstItem .el-form-item__content {
  width: 100;
}
.search >>> .el-checkbox__label {
  color: #999 !important;
}
</style>
<style>
.el-message-box .el-button--primary {
  background-color: #8bb644 !important;
  border-color: #8bb644 !important;
}
</style>

